import React, { useRef, useState } from "react";
import { I, T } from "services/lang/LanguageService";
import { ContextMenu } from "primereact/contextmenu";
import useTabId from "hooks/dashboard/useTabId";
import useDashboardStore from "store/dashboard-store";
import { ProgressSpinner } from "primereact/progressspinner";
import DashboardTabGroup from "./DashboardTabGroup";
import Reorder from "./reorder/Reorder";
import { ReorderType } from "./reorder/DraggableItem";
import { ContextMenuItem } from "../layouts/interfaces";

const DashboardTab = () => {
  const tabId = useTabId();

  const isEditMode = useDashboardStore(state => state.isEditMode);
  const dashboard = useDashboardStore(state => state.dashboard);
  const getTab = useDashboardStore(state => state.getTab);
  const isGroupReorderEnabled = useDashboardStore(state => state.isGroupReorderEnabled);
  const setIsGroupReorderEnabled = useDashboardStore(state => state.setIsGroupReorderEnabled);
  const refreshKey = useDashboardStore(state => state.refreshKey);

  const cm = useRef<ContextMenu>(null);
  const [currentContextMenuItems, setCurrentContextMenuItems] = useState<ContextMenuItem[]>();

  if (!dashboard) {
    return <ProgressSpinner />;
  }

  const currentTab = getTab(tabId);

  if (!currentTab) {
    return <div>{T("message.tab-not-found")}</div>;
  }

  document.title = `DWEEN - ${I(currentTab.title)}`;

  return (
    <div key={refreshKey}>
      <div>
        {isEditMode && <ContextMenu model={currentContextMenuItems} ref={cm} />}
        {currentTab.componentGroups?.map(group => (
          <DashboardTabGroup
            key={group.id}
            group={group}
            tabId={tabId}
            onContextMenu={(e: React.SyntheticEvent<Element, Event>) => cm.current?.show(e)}
            setCurrentContextMenuItems={setCurrentContextMenuItems}
          />
        ))}
      </div>
      {isGroupReorderEnabled && (
        <Reorder
          setReorderDialogVisibility={setIsGroupReorderEnabled}
          reorderDialogVisibility={isGroupReorderEnabled}
          reorderType={ReorderType.GROUPS}
          tabId={tabId}
        />
      )}
    </div>
  );
};

export default DashboardTab;
